import { useTheme } from '@mui/material/styles';

export const ReportButtonsStyles = () => {
  const theme = useTheme();

  return {
    '& .ReportButtons__wrapper': {
      bottom: "0",
      display: "flex",
      position: "fixed",
      right: "0",
      zIndex: "2",
    },
    '& .ReportButtons__item': {
      borderBottomLeftRadius: "0",
      borderBottomRightRadius: "0",
      color: "#fff",
      fontWeight: "bold",
    },
    '& .ReportButtons__item:first-of-type': {
      marginRight: "4px",
    },
    '& .ReportButtons__item.bugReport': {
      background: theme.palette.primary.main,
    },
    '& .ReportButtons__item.helpDeskButton': {
      background: theme.palette.primary.light,
    },
    '#helpReportContainer, #bugReportContainer': {
      bottom: "0",
      display: "none",
      position: "fixed",
    }
  }
}
